const QUOTE_EDGES = /^(?:["'“”‘’]|%22|%27)+|(?:["'“”‘’]|%22|%27)+$/gi;

export function sanitizeUrlKey(value: string): string {
  return value.trim().replace(QUOTE_EDGES, '').trim();
}

export function sanitizeStoredKey(value: string | null): string | null {
  return value === null ? null : sanitizeUrlKey(value);
}
